/**
 * Route guard for `/projects/:id` (Project Details hub).
 *
 * Broader than `PageAccessGuard feature="projects" subFeature="details"`:
 * tenant Admin, platform admin, and users with parent Projects view may enter
 * even when the details child eye is off.
 */

import React, { type ReactNode } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext'
import { canEnterProjectDetailsPage } from '../../features/projects/projectDetailsAccess'
import { useCanAccess } from '../../hooks/useCanAccess'
import { UnauthorizedBanner } from './UnauthorizedBanner'

interface ProjectDetailsAccessGuardProps {
  children: ReactNode
}

export const ProjectDetailsAccessGuard: React.FC<ProjectDetailsAccessGuardProps> = ({
  children,
}) => {
  const { canViewUI, isLoading, isPlatformAdmin } = useCanAccess()
  const { isLoading: isFlagsLoading } = useFeatureFlags()
  const { currentUser } = useAuth()
  if (isLoading || isFlagsLoading) return null
  if (!canEnterProjectDetailsPage({ canViewUI, isPlatformAdmin, currentUser })) {
    return <UnauthorizedBanner />
  }
  return <>{children}</>
}

export default ProjectDetailsAccessGuard
